<template>
  <div class="homepage">
    <div class="cpage">
      <div class="lfmains">
        <div class="mainbox">
          <div class="selectbox">
            <a href="javascript:void(0);" :class='{ "act": cur == index }' @click='pCk(i.ref, index)'
              v-for='(i, index) in Nav' :key="index"><span>{{ i.tit }}({{ home[i.nums] }})</span></a>
          </div>
          <div class="mains">
            <His v-if='cur == 0' :putData='formKey.His' :NumList='Nav[0].url'></His>
            <Over ref='Over' v-if='cur == 1' :putData='formKey.Over'></Over>
            <Payback ref='Payback' v-if='cur == 2' :putData='formKey.Payback'></Payback>
            <Collect ref='Collect' v-if='cur == 3' :putData='formKey.Collect'></Collect>
            <Time ref='Collect' v-if='cur == 4' :putData='formKey.Time'></Time>
            <Carry ref='Carry' v-if='cur == 5' :putData='formKey.Carry' :NumList='Nav[5].url'></Carry>
            <Infos ref='Infos' v-if='cur == 6' :putData='formKey.Infos'></Infos>
            <Email ref="Email" v-if="cur == 7" :putData='formKey.Email' :NumList='Nav[7].url'></Email>
            <Auction ref="Auction" v-if="cur == 8" :putData='formKey.Auction' :NumList='Nav[8].url'></Auction>
          </div>
        </div>
      </div>
      <div class="tool">
        <a-spin tip="加载中" :spinning="!load" />
        <div class="conbox" v-if="load">
          <Dealt />
          <Medium />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*
  望仔细阅读配合store里的home进行阅读
  data下的Nav解析：
  ref：对应的ref用于调用初始化和显示ui
  nums: 各自总数
  url： 用于当下表格下的子表格的头部数量显示 根据type来叠加各自的数量 因为一个二级栏目下可能有多个三级栏目 故需要三级累加给二级用于显示 dispatch('Home/seth')
*/
import formKey from './formKey'
import cmps from './reg'
export default {
  data() {
    return {
      load: false,
      Nav: [
        {
          ref: "His", tit: "新增记录", nums: 'newItemCount',
          url: [
            // { type: 0, url: 'cause/comments/remind?connect_type=1', key: "welcome:new:communicate:cause" },
            // { type: 0, url: 'cause/comments/remind?connect_type=2', key: "welcome:new:communicate:beforExec" },
            { type: 1, url: '/system_info', key: "welcome:new:communicate", other: true },
            // { type: 1, url: 'actionLog/newCauseStepRemind', key: "welcome:new:step:index" },
            // { type: 2, url: 'debtor/newDebtorRemind/list', key: "welcome:new:debtor:index" },
            // { type: 3, url: 'shipRemind/index?source=1', key: "welcome:email" },
            // { type: 3, url: 'shipRemind/index?source=3', key: "welcome:email" },
            // { type: 3, url: 'shipRemind/index?source=2', key: "welcome:email" },
            //source:1其他，2补充材料，3接收材料,4 裁判文书材料
          ]
        },
        {
          ref: "Over", tit: "进度超期", nums: 'stepRemindCount'
        },
        {
          ref: "Payback", tit: "分期履行", nums: 'loanCount',
          url: [
            { type: 3, url: '/system_info', key: "welcome:loan" },
          ]
        },
        {
          ref: "Collect", tit: "保全到期", nums: 'keepCount',
          url: [
            { type: 4, url: '/system_info', key: "welcome:keep" },
          ]
        },
        {
          ref: "Time", tit: "诉讼时效", nums: 'causeAgingCount',
          url: [
            { type: 5, url: '/system_info', key: "welcome:causeAging:index" },
          ]
        },
        {
          ref: "Carry", tit: "执行时效", nums: 'carryCount',
          url: [
            { type: 6, url: '/system_info', key: "welcome:carry:index" },
          ]
        },
        {
          ref: "Infos", tit: "审核提醒", nums: 'auditCount',
          url: [
            { type: 1, url: 'audit/lists', key: "" },
          ]
        },
        {
          ref: "Email", tit: "邮寄提醒", nums: 'emailCount',
          url: [
            { type: 8, url: '/system_info', key: "welcome:emailmsg" },
          ]
        },
        {
          ref: "Auction", tit: "拍卖提醒", nums: 'auctionCount',
          url: [
            { type: 9, url: '/system_info', key: 'welcome:sell' },
          ]
        },

      ],
      formKey,
      cur: 0
    }
  },
  computed: {
    home() {
      // console.log(this.$store.state.Home.Data.newItemCount, this.$store.state.Home.Top.shipRemind.total, this.$store.state.Home.Top.talkData.total
      // );
      return this.$store.state.Home.Data
    }
  },
  created() {
    this.$store.dispatch('Home/seth').then(() => {
      this.load = true;
    })
    this.getP('His')
  },
  methods: {
    async getP(ref) {
      let url = this.Nav.find(ele => {
        return ele.ref == ref
      }).url
      if (url) {
        url.map(ele => {
          ele.open = ele.key ? this.$common.AUTH(ele.key) : true
        })
        this.$store.dispatch('Home/getKey', url)
      }
    },
    async pCk(name, type) {
      if (type != 1) {
        this.getP(name)
      }
      let p = new Promise((resolve, reject) => {
        this.cur = type
      })
      await this.$store.dispatch('Home/seth')//总数据获取数据 
      await p
      await this.$refs[name].resh()
    }
  },
  components: { ...cmps }
}
</script>
<style lang="less">
.homepage {
  display: flex;
  background: #fff;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 20px 20px;
  // border-top: 2px solid #5f8ad2;

  .cpage {
    display: flex;
    background: url("../../assets/img/hbg.png") no-repeat;
    background-size: cover;
    justify-content: space-between;
    width: 100%;
    padding: 20px;
  }

  .pages {
    padding: 12px 0;
  }

  .lfmains {
    background: #fff;
    width: 78.25%;
    margin-right: 10px;
  }

  .tool {
    width: 21.75%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    .conbox {
      text-align: left;
      width: 100%;
    }
  }

  .mainbox {
    height: 614px;

    position: relative;
    box-sizing: border-box;
    padding: 0 18px;
    width: 100%;

    .selectbox {
      height: 48px;
      padding-top: 20px;
      width: 100%;
      line-height: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #dddddd;
      padding-bottom: 8px;
      margin-bottom: 12px;

      span {
        position: relative;
        display: inline-block;
        font-weight: bold;

        &::after {
          display: none;
          height: 4px;
          background: #1d8bfe;
          content: "";
          width: 100%;
          position: absolute;
          bottom: -8px;
        }
      }

      a {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        font-size: 14px;
        color: #333;
        position: relative;
      }

      .act {
        color: #1d8bfe;
        font-weight: bold;

        span {
          &::after {
            display: block;
          }
        }
      }
    }

    .mains {
      // height: 482px;
      width: 100%;
      position: relative;

      .cellbox {
        height: 100%;
        background: #ffffff;
        border-radius: 2px;
        box-sizing: border-box;
        padding: 0 20px;
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
      }

    }
  }

  .table {
    background: #fff;
    padding: 16px 0 0;
    min-height: 460px;

    .curpoter {
      color: #66707c;

      &:hover {
        color: #1d8bfe;
      }
    }

    thead {
      td {
        height: 38px;
        font-weight: bold;
      }
    }

    tbody {
      border-bottom: 1px solid #ebebeb;

      td {
        height: 38px;
        white-space: nowrap;
      }

      .isread {
        td {
          color: rgba(102, 112, 124, 0.5);

          a {
            color: rgba(102, 112, 124, 0.5);
          }
        }
      }
    }
  }
}

@media screen and (max-width:1024px) {
  .homepage {
    .cpage {
      flex-wrap: wrap;
    }

    .tool,
    .lfmains {
      width: 100%;
    }
  }
}
</style>